import {
  AddressMeterPointDetails,
  CreateEvChargerQuoteRequest,
} from "@/api/model"
import { buildFullAddressLine } from "@/lib/shared/addressHelper"
import { readonly, ref } from "vue"

export type EvChargerQuotePersonalDetails = Pick<
  CreateEvChargerQuoteRequest,
  | "title"
  | "firstName"
  | "lastName"
  | "emailAddress"
  | "phoneNumber"
  | "isAuthorisedToAlter"
>

const evChargerQuotePersonalDetails = ref<EvChargerQuotePersonalDetails>({
  firstName: "",
  lastName: "",
  emailAddress: "",
  phoneNumber: "",
  isAuthorisedToAlter: false,
})

const createEvChargerQuoteRequest = ref<CreateEvChargerQuoteRequest>({
  ...evChargerQuotePersonalDetails.value,
  postCode: "",
  address: "",
  hasOffStreetParking: undefined,
})

export const useEvChargerQuote = () => {
  const updateParking = (hasOffStreetParking: boolean) => {
    createEvChargerQuoteRequest.value.hasOffStreetParking = hasOffStreetParking
  }

  const updateAddress = (data: AddressMeterPointDetails) => {
    const fullAddress = data.fullAddress ?? buildFullAddressLine(data.address)
    createEvChargerQuoteRequest.value.address = fullAddress
    createEvChargerQuoteRequest.value.postCode = data.address.postcode
  }

  const updatePersonalDetails = (data: EvChargerQuotePersonalDetails) => {
    createEvChargerQuoteRequest.value = {
      ...createEvChargerQuoteRequest.value,
      ...data,
    }
  }

  return {
    updateParking,
    updateAddress,
    updatePersonalDetails,
    evChargerQuotePersonalDetails,
    createEvChargerQuoteRequest: readonly(createEvChargerQuoteRequest),
  }
}
